export default "__VITE_ASSET__Bt0GV8Jy__"